export const ROUTER_ADMIN = {
    PRODUCT_LIST: "/admin/products",
    UPDATE_PRODUCT: "/admin/products/:id",
    CREATE_PRODUCT: "/admin/products/create",
}